import getConfig from 'next/config';

const config = getConfig();
const {publicRuntimeConfig} = config || {};

// TODO (websdk-ms-1-phase-play): Retest this after switching to monorepo

const SkillzPackageVersion = publicRuntimeConfig?.version || 'N/A';

export default SkillzPackageVersion;
